const MProvider = [
  {
    title: 'Dashboard',
    is_heading: false,
    is_active: false,
    link: {
      name: 'provider.dashboard'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-objects-column',
    active_icon: 'fad fa-objects-column'
  }
]

const MProviderAccounts = [
  {
    title: 'Accounts',
    is_heading: true,
    is_active: false,
    link: {
      name: 'provider.accounts'
    },
    class_name: 'mt-3 font-weight-bolder'
  },
  {
    title: 'Organizations',
    is_heading: false,
    is_active: false,
    link: {
      name: 'provider.accounts.organizations'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-diagram-subtask',
    active_icon: 'fad fa-diagram-subtask'
  },
  {
    title: 'Card Holders',
    is_heading: false,
    is_active: false,
    link: {
      name: 'provider.accounts.card-holders'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-hand-holding-box',
    active_icon: 'fad fa-hand-holding-box'
  },
  {
    title: 'Users',
    is_heading: false,
    is_active: false,
    link: {
      name: 'provider.accounts.users'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-user-visor',
    active_icon: 'fad fa-user-visor'
  }
]

const MProviderServices = [
  {
    title: 'Services',
    is_heading: true,
    is_active: false,
    link: {
      name: 'provider.services'
    },
    class_name: 'mt-3 font-weight-bolder'
  },
  {
    title: 'Packages',
    is_heading: false,
    is_active: false,
    link: {
      name: 'provider.services.packages'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-box-taped',
    active_icon: 'fad fa-box-taped'
  },
  {
    title: 'Diagnostics',
    is_heading: false,
    is_active: false,
    link: {
      name: 'provider.services.diagnostics'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-user-doctor-hair',
    active_icon: 'fad fa-user-doctor-hair'
  },
  {
    title: 'Cards',
    is_heading: false,
    is_active: false,
    link: {
      name: 'provider.services.cards'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-id-card',
    active_icon: 'fad fa-id-card'
  }
]

const MProviderLocations = [
  {
    title: 'Locations',
    is_heading: true,
    is_active: false,
    link: {
      name: 'provider.locations'
    },
    class_name: 'mt-3 font-weight-bolder'
  },
  {
    title: 'Regions',
    is_heading: false,
    is_active: false,
    link: {
      name: 'provider.locations.regions'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-earth-asia',
    active_icon: 'fad fa-earth-asia'
  },
  {
    title: 'Provinces',
    is_heading: false,
    is_active: false,
    link: {
      name: 'provider.locations.provinces'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-map-location-dot',
    active_icon: 'fad fa-map-location-dot'
  },
  {
    title: 'Municipalities',
    is_heading: false,
    is_active: false,
    link: {
      name: 'provider.locations.municipalities'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-mountain-city',
    active_icon: 'fad fa-mountain-city'
  },
  {
    title: 'Barangays',
    is_heading: false,
    is_active: false,
    link: {
      name: 'provider.locations.barangays'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-archway',
    active_icon: 'fad fa-archway'
  }
]

export default MProvider.concat(
  MProviderAccounts,
  MProviderServices,
  MProviderLocations
)
